require('../../modules/es6.string.starts-with');
module.exports = require('../../modules/_core').String.startsWith;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/string/starts-with.js
// module id = 354
// module chunks = 0